import PropTypes from 'prop-types'
import React from 'react'

const stripTags = text => text.replace(/<.+?>/g, '').replace(/&.+;/g, '')

export const Description = ({description}) => description ? (
  <div className='oglasi-opis'>
    <div className='oglasi-info-heading'>
      <p>Opis oglasa</p>
    </div>
    <p className='oglasi-opis-text'>{stripTags(description)}</p>
  </div>
) : null

Description.propTypes = {
  description: PropTypes.string
}
